export default {
  // Title
  title: 'Embodied AI Agent Cluster',
  applicationScenarios: 'Application Scenarios',
  scenariosEmpty: 'No application scenarios yet',
  clusterEmpty: 'No cluster devices yet',

  // Device categories
  categories: {
    robot: 'Robots',
    dog: 'Robot Dogs',
    drone: 'Drones',
    arm: 'Robotic Arms',
    hand: 'Dexterous Hands',
  },

  // Device status
  status: {
    online: 'Online',
    offline: 'Offline',
    fault: 'Fault',
  },

  // Location names
  locations: {
    shanghaiZhangjiang: 'Shanghai Zhangjiang',
    shenzhenFutian: 'Shenzhen Futian',
  },

  // Device state descriptions
  deviceStates: {
    working: 'Working',
    standby: 'Standby',
    upgrading: 'Upgrading',
    charging: 'Charging',
    shutdown: 'Shutdown',
    maintenance: 'Maintenance',
  },

  // Device names
  devices: {
    pianist: 'TermiTech TermiPianist',
    h1: 'Unitree H1',
    x2: 'AGIBOT X2',
    go2: 'Unitree Go2',
    d1: 'AGIBOT D1 Ultra',
    m4td: 'DJI Matrice 4TD',
    ap3: 'DJI Dock 3',
    termiArm: 'TermiTech TermiArm',
    luoshiArm: 'Rokae xMate ER3 Pro',
    termiHand: 'TermiTech TermiHand',
    yinshiHand: 'Yinshi Model',
  },

  // Scenarios
  scenarios: {
    piano: {
      title: 'Piano Performance',
      description: 'Multi-degree-of-freedom robotic arm and dexterous hand collaboration for high-precision humanized performance',
      tags: ['Artistic Performance', 'Automatic Fingering'],
    },
    smtLoading: {
      title: 'SMT Reel Picking Robot',
      description: 'Industrial robot automatically handles material loading and unloading on SMT lines, improving continuous operation efficiency and stability',
      tags: ['Automated Loading', 'Cycle Time Optimization'],
    },
    garmentPrinting: {
      title: 'Industrial Garment Printing',
      description: 'Robotic arm + visual positioning for automated garment printing with high-precision pattern registration and flexible batch production',
      tags: ['Visual Positioning', 'Batch Printing'],
    },
    c919: {
      title: 'Aircraft Cockpit Management',
      description: 'Robotic arm + simulated human-computer interaction for automated avionics knob and switch testing',
      tags: ['Aviation Simulation', 'High Reliability'],
    },
  },

  // Common
  deviceId: 'ID',
  location: 'Location',
}
